import script from "./TheHero.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHero.vue?vue&type=script&setup=true&lang=js"

import "./TheHero.vue?vue&type=style&index=0&id=2e5e9c27&lang=scss"

const __exports__ = script;

export default __exports__